var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedOption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54617_20186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.91797 1.9486C10.7978 2.45659 11.5297 3.18557 12.0412 4.06335C12.5527 4.94114 12.8261 5.9373 12.8343 6.95321C12.8425 7.96913 12.5852 8.96957 12.088 9.8555C11.5907 10.7414 10.8707 11.4821 9.99919 12.0043C9.12769 12.5264 8.13493 12.8119 7.11919 12.8325C6.10345 12.853 5.09996 12.6079 4.20804 12.1215C3.31613 11.635 2.56673 10.9241 2.03402 10.059C1.50132 9.19389 1.20379 8.20468 1.17089 7.18926L1.16797 7.00026L1.17089 6.81126C1.20355 5.80384 1.4967 4.82207 2.02176 3.96168C2.54681 3.10128 3.28585 2.39161 4.16682 1.90186C5.04779 1.41211 6.04064 1.15899 7.04856 1.16718C8.05647 1.17538 9.04507 1.44459 9.91797 1.9486ZM9.16372 5.42118C9.06327 5.32074 8.92963 5.26041 8.78787 5.25149C8.6461 5.24258 8.50595 5.2857 8.39372 5.37276L8.33889 5.42118L6.41797 7.34151L5.66372 6.58785L5.60889 6.53943C5.49664 6.45243 5.35652 6.40936 5.21479 6.4183C5.07306 6.42724 4.93946 6.48758 4.83904 6.588C4.73862 6.68842 4.67828 6.82202 4.66934 6.96375C4.6604 7.10548 4.70347 7.2456 4.79047 7.35785L4.83889 7.41268L6.00555 8.57935L6.06039 8.62776C6.16269 8.70713 6.28849 8.75021 6.41797 8.75021C6.54745 8.75021 6.67325 8.70713 6.77555 8.62776L6.83039 8.57935L9.16372 6.24601L9.21214 6.19118C9.2992 6.07894 9.34232 5.9388 9.3334 5.79703C9.32449 5.65527 9.26415 5.52163 9.16372 5.42118Z",
    fill: "#003A9B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54617_20186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedOption);
export default __webpack_public_path__ + "static/media/selected-option.ba888d176478e9a37e552a76ddc2fccd.svg";
export { ForwardRef as ReactComponent };